import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useGoogleBusinessConnection } from "@/domains/settings/features/integrations/google-business/hooks/use-google-business-connection";

/**
 * "Sync from Google" action shown next to the address and opening-hours fields
 * in Business settings. Pulls the salon's address + operating hours from the
 * linked Google Business Profile. Renders nothing when the salon has no GBP
 * connection (there's nothing to sync from).
 */
export function SyncFromGoogleButton() {
  const { connection, syncLocationNow, syncingLocation } = useGoogleBusinessConnection();
  if (!connection) return null;

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={() => void syncLocationNow()}
      disabled={syncingLocation}
    >
      <RefreshCw className={`mr-2 h-4 w-4 ${syncingLocation ? "animate-spin" : ""}`} />
      {syncingLocation ? "Syncing…" : "Sync from Google"}
    </Button>
  );
}
